import { render, staticRenderFns } from "./dialogClose.vue?vue&type=template&id=a074dbcc&scoped=true&"
import script from "./dialogClose.vue?vue&type=script&lang=js&"
export * from "./dialogClose.vue?vue&type=script&lang=js&"
import style0 from "./dialogClose.vue?vue&type=style&index=0&id=a074dbcc&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a074dbcc",
  null
  
)

export default component.exports